// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"1aea44f6","879":"e724ed78"}[chunkId] + ".chunk.js";
};